var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Http, timeoutMiddleware, } from '@fe/g-utils';
import { getSharkParams, getExtraBodyParams } from '../sharkReport/index';
import { loadScript } from '../../utils/loadScriptNoCache';
import { parseQuery, getType, isSandbox } from '../../utils/index';
import { codeMiddleware, isStrategyReturnType } from './code';
// import { logIdMiddleware } from './logId';
import { logger } from '../logger';
var requestPairs = []; //读写配对组
// let requestCooldownList = [];//读冷却组
//设置读写配对
export function setRequestPairs(list) {
    requestPairs.length = 0;
    list.forEach(function (i) {
        if (i.read && i.write) {
            requestPairs.push({
                read: i.read,
                write: i.write
            });
        }
    });
}
//执行写
// function writePairs(process_id) {
//   requestPairs.forEach(i => {
//     if (i.write == process_id) {
//       requestCooldownList.push({
//         id: i.read,
//         time: new Date().getTime() + 500,
//       });
//     }
//   });
// }
//延迟执行
function delay() {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            resolve();
        }, 100);
    });
}
//执行读
// async function readPairs(process_id) {
//   for (let i in requestCooldownList) {
//     if (requestCooldownList[i] && requestCooldownList[i].id == process_id) {
//       while (requestCooldownList[i].time >= new Date().getTime()) {
//         await delay();
//       }
//       delete requestCooldownList[i];
//     }
//   }
//   requestCooldownList = requestCooldownList.filter(i => {
//     return i
//   });
// }
var fetchOrigin = function (url, options) {
    return window.fetch(url, options);
};
export var fetch = new Http(fetchOrigin);
var commonRequest = new Http(fetchOrigin);
// 超时middleware
var timeoutHandle = function (ctx, next) { return __awaiter(void 0, void 0, void 0, function () {
    var ins;
    return __generator(this, function (_a) {
        try {
            ins = timeoutMiddleware(ctx.req.timeout || 5000);
            return [2 /*return*/, ins(ctx, next)];
        }
        catch (e) {
            throw e;
        }
        return [2 /*return*/];
    });
}); };
fetch.useMiddleware(timeoutHandle);
commonRequest.useMiddleware(codeMiddleware());
commonRequest.useMiddleware(timeoutHandle);
// commonRequest.useMiddleware(logIdMiddleware);
// 风控签名拦截机制
commonRequest.useMiddleware(function (ctx, next) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, url, data, body, _b, region, _c, method, _d, useSharkSign, postData, acrawlerUrl, contentType, nonce, sig, sign_url;
    var _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = ctx.req, url = _a.url, data = _a.data, body = _a.body, _b = _a.region, region = _b === void 0 ? 'cn' : _b, _c = _a.method, method = _c === void 0 ? 'get' : _c, _d = _a.useSharkSign, useSharkSign = _d === void 0 ? true : _d;
                postData = data || body;
                if (!(url.indexOf('_signature') > -1 || !useSharkSign)) return [3 /*break*/, 2];
                return [4 /*yield*/, next()];
            case 1: return [2 /*return*/, _f.sent()];
            case 2:
                if (!(method.toLowerCase() === 'post' &&
                    (getType(postData) === 'Object' || getType(postData) === 'JSON'))) return [3 /*break*/, 5];
                ctx.req.data = postData;
                ctx.req.body = postData;
                if (!!window.byted_acrawler) return [3 /*break*/, 4];
                acrawlerUrl = void 0;
                if (region === 'sg') {
                    acrawlerUrl =
                        'https://sf-tk-sg.ibytedtos.com/obj/rc-web-sdk-sg/acrawler.js';
                }
                else if (region === 'va') {
                    acrawlerUrl =
                        'https://sf16-muse-va.ibytedtos.com/obj/rc-web-sdk-gcs/acrawler.js';
                }
                else {
                    acrawlerUrl =
                        'https://lf3-cdn-tos.bytescm.com/obj/rc-web-sdk/acrawler.js';
                }
                return [4 /*yield*/, loadScript(acrawlerUrl, function () {
                        return !!window.byted_acrawler;
                    })];
            case 3:
                _f.sent();
                _f.label = 4;
            case 4:
                contentType = ((_e = ctx.req) === null || _e === void 0 ? void 0 : _e.headers['Content-Type']) || 'application/json';
                nonce = {
                    url: encodeURI(url),
                    body: postData,
                    bodyVal2str: contentType === 'application/x-www-form-urlencoded', // 仅在 Content-Type 为 application/x-www-form-urlencoded 时开启
                };
                sig = window.byted_acrawler.sign(nonce);
                sign_url = url +
                    (nonce.url.indexOf('?') !== -1
                        ? '&_signature=' + sig
                        : '?_signature=' + sig);
                ctx.req.url = sign_url;
                ctx.url = sign_url;
                _f.label = 5;
            case 5: return [4 /*yield*/, next()];
            case 6: return [2 /*return*/, _f.sent()];
        }
    });
}); });
// 公共请求函数
export var request = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var url, sharkParams, data, body, _a, headers, _b, forcePPE, _c, useSharkParam, originData, shark_params, extraBodyParams, querys, params, res, logId, resdata, e_1;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 3, , 4]);
                url = options.url, sharkParams = options.sharkParams, data = options.data, body = options.body, _a = options.headers, headers = _a === void 0 ? {} : _a, _b = options.forcePPE, forcePPE = _b === void 0 ? false : _b, _c = options.useSharkParam, useSharkParam = _c === void 0 ? true : _c;
                originData = void 0;
                if (data) {
                    originData = data;
                }
                else if (body) {
                    if (typeof body === 'string') {
                        originData = JSON.parse(body);
                    }
                    else {
                        originData = body;
                    }
                }
                else {
                    originData = {};
                }
                if (sharkParams && useSharkParam) {
                    shark_params = getSharkParams(sharkParams);
                    extraBodyParams = getExtraBodyParams(sharkParams.app_id || '');
                    querys = parseQuery();
                    params = __assign(__assign(__assign(__assign({}, querys), extraBodyParams), { shark_params: shark_params }), originData);
                    options.data = params;
                }
                else {
                    options.data = originData;
                }
                // 线上自动去掉ppe header
                if (!isSandbox() && !forcePPE) {
                    delete headers['x-use-ppe'];
                    delete headers['x-tt-env'];
                }
                return [4 /*yield*/, commonRequest.request(url, __assign({}, options))];
            case 1:
                res = _d.sent();
                // 上报自定义监控
                logger.custom('GameSDK request', { response: res, request: options });
                //写入写配对
                // if (processId) {
                //   writePairs(processId);
                // }
                if (isStrategyReturnType(res)) {
                    return [2 /*return*/, res];
                }
                logId = res.headers.get('x-tt-logid') || '';
                return [4 /*yield*/, res.json()];
            case 2:
                resdata = _d.sent();
                return [2 /*return*/, __assign(__assign({}, resdata), { logId: logId })];
            case 3:
                e_1 = _d.sent();
                throw e_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
export default fetch.child();
export { codeMiddleware, strategyCreator } from './code';
export { logIdMiddleware } from './logId';
//# sourceMappingURL=index.js.map